export class SelectedSchoolTimetable {
  static readonly type = '[SchoolTimetable] timetable';
  constructor(public schoolTT: any) {}
}
